export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11753.7a8f509e.jpg";